import { useMemo } from 'react';
import { toTemplateModelsObject } from 'presentation/inspection/toTemplateModelsObject';
import { HashMap } from 'shared/types/commonView';
import { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';
import { useInspectionTemplates } from '../useInspectionTemplates';

export interface UseInspectionTemplatesObjectResult {
  templates: HashMap<InspectionTemplateModel>;
  loading: boolean;
}

export function useInspectionTemplatesObject(): UseInspectionTemplatesObjectResult {
  const { inspectionTemplates, loading } = useInspectionTemplates();

  const templates = useMemo(
    () => inspectionTemplates.items.reduce(toTemplateModelsObject, {}),
    [inspectionTemplates.items]
  );

  return {
    templates,
    loading,
  };
}
